<template>
<loader v-bind="{ loading }">
  <form>
    <div class="columns">
      <div class="column">
        <text-input
          required
          :value="scraper.name"
          @input="updateName"
          :error="$root.errorBag.name">
          Name
        </text-input>
      </div>
      <div class="column">
        <switch-input
          required
          :value="scraper.scrapes_on_client"
          @input="toggleClientSideScraping"
          :error="$root.errorBag.scrapes_on_client">
          Scrapes Client Side
        </switch-input>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <text-area
          required
          :value="scraper.description"
          @input="updateDescription"
          :error="$root.errorBag.description">
          Description
        </text-area>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <text-input
          :value="scraper.return_value"
          @input="updateReturnValue"
          :error="$root.errorBag.return_value"
          description="Indicates the data type that will be returned from a scrape, e.g. string or collection">
          Data Return Type
        </text-input>
      </div>
    </div>

    <h5 class="title is-4">Scraping Logic</h5>

    <div class="columns">
      <div class="column">
        <text-input
          disabled
          :value="scraper.scraper.handler"
          :description="`Key: ${scraper.scraper.key}`">
          Scraper
        </text-input>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <submit-button
          :working="saving"
          @submit="save">
          Save
        </submit-button>
      </div>
    </div>
  </form>
</loader> 
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import PayloadBuilder from './payload/Builder.vue'

export default {

  components: {
    PayloadBuilder
  },

  data: () => ({
    loading: true,
    saving: false,
  }),
  
  created() {
    this.$store.dispatch('scraper/loadScraper', this.$route.params.scraper)
      .then(() => this.loading = false)
      .catch(() => this.loading = false)
  },

  methods: {
    ...mapMutations('scraper', [
      'updateName',
      'updateDescription',
      'updateHandlerExample',
      'toggleClientSideScraping',
      'updatePayload',
      'updateReturnValue'
    ]),
    save() {
      this.saving = true
      this.$store.dispatch('scraper/save').then(() => {
        this.$toast.success('Saved')
        this.saving = false
      }).catch(error => this.saving = false)
    }
  },

  computed: {
    ...mapGetters('scraper', [
      'scraper'
    ])
  }

}
</script>